import React from "react";

function GotsIcon() {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 652 652"
        style={{ width: "50px", height: "50px", display: "block" }}
        aria-hidden="true"
      >
        <style>
          {`.st0-62624ba9350b5{fill:#020202;} .st1-62624ba9350b5{fill:#1C1C1B;} .st2-62624ba9350b5{fill:#FFFFFF;}`}
        </style>
        <g>
          <path
            className="st0-62624ba9350b5"
            d="M320.3,132.6c-104.4,0-188.9,84.6-188.9,188.9c0,104.4,84.6,188.9,188.9,188.9s188.9-84.6,188.9-188.9 C509.2,217.2,424.6,132.6,320.3,132.6"
          ></path>
          <path
            className="st0-62624ba9350b5"
            d="M185,491.2c8.6,6.7,10.8,16.4,3.8,25.3c-6.7,8.5-17.3,8.7-25.5,2.3c-2.7-2.1-5.5-4.9-7.4-7.7l3.8-4.3 c1.3,2.7,3.4,5,5.7,6.9c5.9,4.6,12.6,3.9,17.2-2c4.2-5.3,4.8-11.7-1-16.2c-1.4-1.1-2.9-2-4.7-2.6l-4.5,5.7l3.5,2.8l-3.1,3.9 l-8.8-6.9l10.1-12.9C178.2,486.7,181.7,488.7,185,491.2"
          ></path>
          <polygon
            className="st0-62624ba9350b5"
            points="165,474.1 139.7,496.7 134.7,491.1 155.5,472.5 145.8,461.6 150.3,457.6"
          ></polygon>
          <path
            className="st0-62624ba9350b5"
            d="M137.5,438.1c5.8,9.2,3,17.8-5.9,23.4c-8.7,5.5-18,4.3-23.7-4.7c-5.8-9.2-3.1-17.8,5.9-23.5 C122.6,427.7,131.8,429,137.5,438.1 M112.4,454c3.5,5.6,10.4,3.8,15.1,0.8c4.6-2.9,9.2-8.4,5.7-14c-3.6-5.7-10.3-3.9-15.1-0.9 C113.2,443,108.7,448.3,112.4,454"
          ></path>
          <path
            className="st0-62624ba9350b5"
            d="M118.8,402.6l4.6,11.5l-31.6,12.6l-5.1-12.9c-2.1-5.2-2.4-11.1,3.7-13.5c4-1.6,7.5-0.2,9.9,3.3 c-0.9-4.2,0.4-8.3,4.7-10C112.4,390.6,116.4,396.4,118.8,402.6 M91.9,414.3l1.6,3.9l9-3.6l-1.3-3.4c-1.2-3.1-3.5-5.9-7.2-4.4 C90.7,408.2,90.8,411.5,91.9,414.3 M105.4,410l1.2,3l9.9-3.9l-1.3-3.3c-1.3-3.2-3.7-6.6-7.6-5C103.2,402.5,104,406.6,105.4,410"
          ></path>
          <path
            className="st0-62624ba9350b5"
            d="M105.9,355.7l-7.8,4.6l2.9,14.2l8.9,1.3l1.5,7.3l-35.9-6l-2-9.7l30.8-19.4L105.9,355.7z M79.3,371.4l16.4,2.6 l-2.2-11.1L79.3,371.4z"
          ></path>
          <polygon
            className="st0-62624ba9350b5"
            points="104,337.6 70,338.4 69.8,330.9 97.8,330.2 97.4,315.6 103.4,315.5"
          ></polygon>
          <path
            className="st0-62624ba9350b5"
            d="M111.4,267.2c-2.8,10.5-11,14.3-21.2,11.6c-10-2.7-15.4-10.3-12.7-20.6c2.8-10.5,11-14.4,21.2-11.7 C108.9,249.3,114.2,256.9,111.4,267.2 M82.6,259.6c-1.7,6.4,4.3,10.2,9.6,11.6c5.3,1.4,12.4,1,14.1-5.3c1.7-6.5-4.1-10.2-9.6-11.7 C91.3,252.8,84.4,253,82.6,259.6"
          ></path>
          <path
            className="st0-62624ba9350b5"
            d="M127.8,223l-10.3-1c-3.5-0.4-4.7-0.1-6.4,3.2l-1.2,2.5l12.7,6.1l-3.2,6.7l-30.7-14.7l6-12.5 c2.5-5.2,7-9.5,13.1-6.5c4.2,2,5.3,6.4,4,10.6c1.9-2.5,3.8-3,6.9-2.7l12.4,1.1L127.8,223z M98.1,218l-1.6,3.3l8.9,4.3l1.5-3.1 c1.5-3.1,2.1-6.8-1.5-8.6C101.8,212.1,99.7,214.7,98.1,218"
          ></path>
          <path
            className="st0-62624ba9350b5"
            d="M147,193.7c-6.4,8.8-16,11.3-25.1,4.8c-8.7-6.3-9.3-17-3.2-25.4c2-2.8,4.7-5.6,7.4-7.6l4.4,3.6 c-2.7,1.4-4.9,3.6-6.6,6c-4.4,6.1-3.4,12.7,2.6,17.1c5.5,4,11.9,4.3,16.2-1.6c1.1-1.5,1.9-3,2.4-4.8l-5.9-4.3l-2.6,3.6l-4-2.9 l6.6-9.1l13.3,9.6C151.2,186.8,149.4,190.4,147,193.7"
          ></path>
          <path
            className="st0-62624ba9350b5"
            d="M179.6,157.7l-8-4.2l-10.6,9.9l3.6,8.3l-5.4,5.1l-13.8-33.7l7.2-6.8l32.7,15.9L179.6,157.7z M152.2,143.3 l6.4,15.3l8.3-7.8L152.2,143.3z"
          ></path>
          <polygon
            className="st0-62624ba9350b5"
            points="209.5,136.5 184.2,119.6 198.9,143.1 193.2,146.7 175.3,117.8 184.6,112 210,129 195.3,105.3 201,101.8 218.9,130.7"
          ></polygon>
          <polygon
            className="st0-62624ba9350b5"
            points="232,124.9 218.6,93.6 225.6,90.6 238.9,121.9"
          ></polygon>
          <path
            className="st0-62624ba9350b5"
            d="M268.3,112.9c-10.6,2.9-19.6-1.1-22.6-12c-2.8-10.3,3.3-19.1,13.3-21.8c2.6-0.7,5.9-1.1,8.5-1.1l1.2,5.5 c-2.2-0.3-4.9-0.1-7.1,0.5c-7,1.9-10.1,7.9-8.3,14.7c1.9,7,7.3,10.5,14.5,8.5c2.4-0.7,4.7-1.7,6.6-3.3l1.7,5.2 C274.1,110.9,271,112.2,268.3,112.9"
          ></path>
          <polygon
            className="st0-62624ba9350b5"
            points="329.1,78.3 328.4,106.3 320.8,106.1 321.5,78.1 310.8,77.9 311,71.9 339.9,72.5 339.7,78.6"
          ></polygon>
          <polygon
            className="st0-62624ba9350b5"
            points="349.1,107.8 355.2,74.4 377,78.3 376,83.5 361.5,80.8 359.9,89.6 373.8,92.1 372.8,97.2 359,94.6 357.3,104 372.2,106.7 371.3,111.8"
          ></polygon>
          <polygon
            className="st0-62624ba9350b5"
            points="403,122.4 399.8,106.5 386.8,116.4 379.1,113.5 396.9,101.2 392.1,82.1 400.2,85.1 403.2,99.4 414.7,90.4 422.2,93.2 406,104.6 411.4,125.4"
          ></polygon>
          <polygon
            className="st0-62624ba9350b5"
            points="444.7,112.1 430.8,136.4 424.2,132.6 438.1,108.4 428.9,103.1 431.8,97.9 456.9,112.2 453.9,117.4"
          ></polygon>
          <rect
            x="444.5"
            y="133"
            transform="matrix(0.6053 -0.796 0.796 0.6053 73.33 421.3046)"
            className="st0-62624ba9350b5"
            width="34"
            height="7.5"
          ></rect>
          <polygon
            className="st0-62624ba9350b5"
            points="466.3,162.5 490.3,138.5 495.7,143.8 475.9,163.6 486.3,173.9 482,178.2"
          ></polygon>
          <polygon
            className="st0-62624ba9350b5"
            points="488.3,185.7 515.6,165.5 528.8,183.3 524.6,186.4 515.8,174.5 508.7,179.8 517,191.1 512.9,194.2 504.5,182.9 496.9,188.5 505.9,200.8 501.7,203.9"
          ></polygon>
          <path
            className="st0-62624ba9350b5"
            d="M522.2,245.8c-1.2-3.3-2.1-6.8-2.3-10.3l5.5-1.8c-0.4,3.3,0.3,6.5,1.4,9.6c1.1,3,3.3,5.7,6.7,4.5 c2.4-0.9,2.5-4.8,2.6-7.4l0.2-3.8c0.2-4.4,1.4-8,5.8-9.6c6.9-2.6,11.8,3.7,13.9,9.5c1,2.7,1.7,5.5,2,8.4l-5.3,1.7 c0.1-2.6-0.5-5.4-1.4-7.9c-1-2.6-3.1-6-6.3-4.8c-2.2,0.8-2.3,4-2.4,6.4l-0.1,3.9c-0.1,4.8-1.1,8.7-6.1,10.6 C529.6,257.4,524.5,252.1,522.2,245.8"
          ></path>
          <polygon
            className="st0-62624ba9350b5"
            points="560.6,277.2 533.2,282.8 531.7,275.4 559.1,269.8 557,259.3 562.8,258.1 568.6,286.4 562.7,287.6"
          ></polygon>
          <path
            className="st0-62624ba9350b5"
            d="M537.1,325.5l8.4-3.3l-0.5-14.4l-8.6-2.8l-0.2-7.4l34.4,11.8l0.3,9.9l-33.5,14.1L537.1,325.5z M565.9,314.4 l-15.7-5.2l0.4,11.4L565.9,314.4z"
          ></path>
          <polygon
            className="st0-62624ba9350b5"
            points="533.4,361.7 562.8,353.8 535.4,349.4 536.4,342.8 570,348.2 568.2,359.1 538.8,367.1 566.2,371.5 565.1,378.1 531.6,372.7"
          ></polygon>
          <path
            className="st0-62624ba9350b5"
            d="M523.8,397l4-10.7l31.8,12.1l-4.5,11.8c-3.9,10.3-11.6,14.1-22,10.2C522.3,416.2,519.9,407.4,523.8,397 M550.7,407.2l1.4-3.7l-22.1-8.4l-1,2.6c-2.7,7.2-0.4,12.3,6.9,15.1C542.3,415.3,548.1,414,550.7,407.2"
          ></path>
          <path
            className="st0-62624ba9350b5"
            d="M500.5,443.3l8.8,1.8l7.5-12.4l-5.7-7l3.8-6.4l22.4,28.7l-5.1,8.5l-35.8-6.5L500.5,443.3z M530.7,449.7 l-10.3-13l-5.9,9.7L530.7,449.7z"
          ></path>
          <path
            className="st0-62624ba9350b5"
            d="M478.2,471.1l9.6,3.8c3.3,1.3,4.5,1.4,7-1.4l1.8-2.1l-10.6-9.3l4.9-5.5l25.5,22.5l-9.2,10.4 c-3.8,4.4-9.3,7.2-14.4,2.7c-3.5-3.1-3.3-7.6-1-11.3c-2.5,1.9-4.5,1.8-7.4,0.7l-11.7-4.4L478.2,471.1z M505.4,484l2.4-2.7l-7.4-6.5 l-2.3,2.6c-2.3,2.6-3.9,6-0.9,8.7C500.3,488.6,503,486.7,505.4,484"
          ></path>
          <path
            className="st0-62624ba9350b5"
            d="M456.3,491.3l9-7.1l21,26.7l-9.9,7.8c-8.6,6.8-17.2,6.2-24.1-2.6C445.2,507,447.6,498.2,456.3,491.3 M474.1,513.9l3.1-2.4L462.6,493l-2.2,1.7c-6.1,4.8-6.7,10.3-1.9,16.5C462.8,516.5,468.5,518.4,474.1,513.9"
          ></path>
        </g>
        <g>
          <path
            className="st1-62624ba9350b5"
            d="M261.8,565.5c-10.6-2.7-16.6-10.7-13.8-21.7c2.6-10.5,12.3-15.1,22.5-12.5c3.3,0.8,7,2.3,9.9,4.1l-1.7,5.5 c-2.3-2-5.2-3.2-8-4c-7.3-1.8-13.2,1.6-15,8.9c-1.7,6.6,0.4,12.7,7.5,14.5c1.8,0.5,3.5,0.7,5.4,0.5l1.8-7.1l-4.4-1.1l1.2-4.8 l10.9,2.7l-4,16C269.9,566.9,265.8,566.5,261.8,565.5"
          ></path>
          <path
            className="st1-62624ba9350b5"
            d="M304.2,571.8c-10.8-0.7-16.1-7.9-15.4-18.5c0.7-10.3,7.1-17,17.7-16.3c10.8,0.7,16.2,7.9,15.5,18.5 C321.2,565.9,314.8,572.5,304.2,571.8 M306,542.3c-6.6-0.4-9.1,6.2-9.5,11.6c-0.4,5.5,1.4,12.3,7.9,12.8c6.7,0.4,9.2-6,9.5-11.6 C314.4,549.4,312.8,542.7,306,542.3"
          ></path>
        </g>
        <polygon
          className="st1-62624ba9350b5"
          points="346.6,543.3 349.4,571 341.9,571.8 339.1,544.1 328.6,545.1 328,539.1 356.6,536.3 357.2,542.2"
        ></polygon>
        <g>
          <path
            className="st1-62624ba9350b5"
            d="M382.7,565.6c-3.3,0.9-6.8,1.4-10.2,1.2l-1.2-5.5c3.2,0.7,6.4,0.4,9.5-0.4c3-0.8,5.9-2.7,5-6.1 c-0.6-2.5-4.4-2.9-7-3.3l-3.6-0.6c-4.2-0.6-7.6-2.2-8.8-6.5c-1.8-7,4.8-11,10.6-12.6c2.7-0.7,5.5-1.1,8.3-1.1l1.1,5.4 c-2.5-0.4-5.3-0.1-7.8,0.5c-2.6,0.7-6.1,2.4-5.3,5.6c0.6,2.2,3.7,2.7,6,2.9l3.8,0.4c4.7,0.6,8.4,2,9.7,7 C394.7,559.5,389,563.9,382.7,565.6"
          ></path>
          <rect
            x="213.3"
            y="529.5"
            transform="matrix(0.4273 -0.9041 0.9041 0.4273 -358.0498 501.5085)"
            className="st1-62624ba9350b5"
            width="7"
            height="7.8"
          ></rect>
          <polygon
            className="st1-62624ba9350b5"
            points="420.1,538.1 417.2,531.9 424.2,528.5 427.2,534.8"
          ></polygon>
          <path
            className="st2-62624ba9350b5"
            d="M163.5,305.9l45.8,45.8l42.6-42.6v135.6h64.8V245.5l-46.4-46.4L163.5,305.9z M370.4,199.2l-46.3,46.3v199.2 h64.8V309.1l42.5,42.5l45.8-45.8L370.4,199.2z"
          ></path>
        </g>
      </svg>
    </div>
  );
}

export default GotsIcon;
